import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinSubtaskActionRoute: InvariantJiraRoute = {
	name: 'legacy-gin-subtask-action',
	path: '/secure/(Move|Convert)SubTask(\\w*)([!%]?[\\w]*).jspa',
};
